"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputSwitch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var framer_motion_1 = require("framer-motion");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var InputSwitchStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  label {\n    ", "\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  label {\n    ", "\n  }\n"])), (0, styles_1.getP18_1)());
var Switch = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  border-radius: 9.5px;\n  display: flex;\n  height: 17px;\n  justify-content: flex-start;\n  padding: 0 1px;\n  position: relative;\n  width: 29px;\n  margin-right: 20px;\n  cursor: pointer;\n\n  &[data-isOn='true'],\n  &[data-is-on='true'] {\n    background: ", ";\n    justify-content: flex-end;\n  }\n\n  input {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    user-select: none;\n    visibility: hidden;\n    z-index: -1;\n  }\n\n"], ["\n  align-items: center;\n  background: ", ";\n  border-radius: 9.5px;\n  display: flex;\n  height: 17px;\n  justify-content: flex-start;\n  padding: 0 1px;\n  position: relative;\n  width: 29px;\n  margin-right: 20px;\n  cursor: pointer;\n\n  &[data-isOn='true'],\n  &[data-is-on='true'] {\n    background: ", ";\n    justify-content: flex-end;\n  }\n\n  input {\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    user-select: none;\n    visibility: hidden;\n    z-index: -1;\n  }\n\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.grey;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.blue;
});
var Handler = (0, styled_components_1.default)(framer_motion_1.motion.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background: white;\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n"], ["\n  background: white;\n  border-radius: 50%;\n  height: 15px;\n  width: 15px;\n"])));
var spring = {
    duration: .3,
    type: 'tween',
    ease: [.25, .1, .25, 1]
};
var InputSwitch = function (_a) {
    var onChange = _a.onChange, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.initValue, initValue = _c === void 0 ? false : _c;
    var _d = __read((0, react_1.useState)(initValue), 2), isOn = _d[0], setIsOn = _d[1];
    var toggleSwitch = function (e) {
        if (e.target.type !== 'checkbox') {
            onChange && onChange(!isOn);
            setIsOn(!isOn);
        }
    };
    (0, react_1.useEffect)(function () {
        if (initValue) {
            setIsOn(initValue);
        }
    }, [initValue]);
    return ((0, jsx_runtime_1.jsxs)(InputSwitchStyled, __assign({ onClick: toggleSwitch }, { children: [(0, jsx_runtime_1.jsxs)(Switch, __assign({ "data-is-on": isOn }, { children: [(0, jsx_runtime_1.jsx)("input", { type: 'checkbox' }), (0, jsx_runtime_1.jsx)(Handler, { layout: true, transition: spring })] })), label && (0, jsx_runtime_1.jsx)("label", { children: label })] })));
};
exports.InputSwitch = InputSwitch;
var templateObject_1, templateObject_2, templateObject_3;
